import { render, staticRenderFns } from "./rankings.vue?vue&type=template&id=3583fc32&"
import script from "./rankings.vue?vue&type=script&lang=coffee&"
export * from "./rankings.vue?vue&type=script&lang=coffee&"
import style0 from "./rankings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports